import { LAYOUT } from '@admin/router/constant'

// 分拣机
const sortingMachineRouter = {
  path: '/sortingMachine',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/wms/sortingMachine/home',
      name: 'WMSSortingMachineHome',
      component: () => import('@admin/views/wms/sortingMachine/home/index.vue'),
      meta: { title: '分拣作业(分拣机)' },
    },
  ],
}

export default [sortingMachineRouter]
